// This icon file is generated automatically.
var PtoMenuListOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "defs", "attrs": {}, "children": [{ "tag": "style", "attrs": {} }] }, { "tag": "path", "attrs": { "d": "M128 213.34h768q17.66 0 30.18 12.52t12.5 30.17-12.5 30.18T896 298.72H128q-17.66 0-30.18-12.51t-12.5-30.18 12.5-30.17T128 213.34zm0 512h768q17.66 0 30.18 12.52t12.5 30.17-12.5 30.18T896 810.72H128q-17.66 0-30.18-12.51t-12.5-30.18 12.5-30.17T128 725.34zm0-256h768q17.66 0 30.18 12.52t12.5 30.17-12.5 30.18T896 554.72H128q-17.66 0-30.18-12.51t-12.5-30.18 12.5-30.17T128 469.34z" } }] }, "name": "pto-menu-list", "theme": "outlined" };
export default PtoMenuListOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoMenuListOutlined.js
// module id = 3914
// module chunks = 0